export const SECTION_LABELS: Record<string, string> = {
  showNotice: "Notice Board",
  showEvent: "Events",
  showFacility: "Facilities",
  showTenantBusiness: "Tenant Business",
  showMarketplaceItem: "Marketplace",
  showService: "Services",
  showLostItem: "Lost Items",
  showFoundItem: "Found Items",
  showAnnouncement: "Announcements",
  showBuySell: "Buy/Sell",
  showFoodCourt: "Food Court",
  showRequestOffer: "Requests/Offers",
  showRetail: "Retail",
  showUrgentHelp: "Time Sensitive Help",
  showAskForHelp: "Ask for Help",
  showLostFound: "Lost & Found",
  showOtherRequests: "Other Requests",
  showJob: "Jobs",
};

export const CONTENT_TYPE_TO_SECTION_KEY: Record<string, string> = {
  NOTICE: "showNotice",
  EVENT: "showEvent",
  FACILITY: "showFacility",
  TENANT_BUSINESS: "showTenantBusiness",
  MARKETPLACE_ITEM: "showMarketplaceItem",
  SERVICE: "showService",
  LOST_ITEM: "showLostItem",
  FOUND_ITEM: "showFoundItem",
  ANNOUNCEMENT: "showAnnouncement",
  BUY_SELL: "showBuySell",
  FOOD_COURT: "showFoodCourt",
  REQUEST_OFFER: "showRequestOffer",
  JOB: "showJob",
};

/** Section keys that appear in the sidebar; used for global and per-location visibility */
export const SIDEBAR_SECTION_KEYS = [
  "showNotice",
  "showEvent",
  "showTenantBusiness",
  "showRetail",
  "showFoodCourt",
  "showFacility",
  "showService",
  "showBuySell",
  "showRequestOffer",
  "showUrgentHelp",
  "showAskForHelp",
  "showShareWithNeighbors",
  "showLostFound",
  "showOtherRequests",
  "showJob",
] as const;

/** Map sidebar path (no leading slash in config) to section key */
export const PATH_TO_SECTION_KEY: Record<string, string> = {
  notices: "showNotice",
  events: "showEvent",
  tenants: "showTenantBusiness",
  retail: "showRetail",
  "food-court": "showFoodCourt",
  facilities: "showFacility",
  services: "showService",
  "buy-sell": "showBuySell",
  "request-offer": "showRequestOffer",
  "immediate-help": "showUrgentHelp",
  "ask-for-help": "showAskForHelp",
  "share-with-neighbors": "showShareWithNeighbors",
  "lost-found": "showLostFound",
  "other-requests": "showOtherRequests",
  jobs: "showJob",
};

export const SECTION_KEYS = Object.keys(SECTION_LABELS);
